import { useFormContext, useWatch } from 'react-hook-form';
import { ui } from '@procuros/datachecks';

import { useNavigationContext } from 'contexts/SchemableFormNavigationContext/SchemableFormNavigationContext';
import { DisplayModes } from 'services/webedi/types';
import { WebEDIAnnotation } from 'services/webediErrors/types';
import { DataDisplay } from 'components/Form/DataDisplay/DataDisplay';
import { SchemableFormTextarea } from 'components/Form/SchemableFormTextarea/SchemableFormTextarea';
import { Translate } from 'components/Translate/Translate';

type LongTextFieldProps = {
  field: ui.LongTextField;
  fieldId: string;
  isReadOnly: boolean;
  mode: DisplayModes;
  variant?: 'large';
};

export const LongTextField = ({ field, fieldId, isReadOnly, mode, variant }: LongTextFieldProps) => {
  const value = useWatch({ name: fieldId });
  const { register } = useFormContext();
  const { service } = useNavigationContext<WebEDIAnnotation>();
  const fieldState = service.useFieldStateFromAnnotations(fieldId);
  const popoverItem = service.useItemByFieldPath(fieldId);
  const setCurrentItem = service.setCurrentItem;

  if (mode === DisplayModes.view) {
    return (
      <DataDisplay
        value={value}
        label={field.label}
        error={popoverItem}
        fieldId={fieldId}
        onShowFieldErrorModal={() => popoverItem && setCurrentItem(popoverItem)}
        description={field.description}
      />
    );
  }

  return (
    <SchemableFormTextarea
      label={field.label}
      description={field.description ? <Translate i18nKey={field.description} /> : undefined}
      error={popoverItem}
      {...register(fieldId)}
      value={value}
      onShowFieldErrorModal={() => popoverItem && setCurrentItem(popoverItem)}
      required={field.modality === 'MANDATORY'}
      disabled={isReadOnly}
      variant={variant}
      fieldState={fieldState}
    />
  );
};
